import React from 'react';
import PropTypes from 'prop-types';
import { TextField as MuiTextField } from '@mui/material';
import BaseField from './BaseField';

/**
 * TextAreaField component for workflow forms.
 * Extends the BaseField with multi-line text input functionality.
 */
const TextAreaField = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  required,
  error,
  helperText,
  disabled,
  fullWidth,
  className,
  rows,
  maxRows,
  inputProps,
  ...rest
}) => {
  return (
    <BaseField
      id={id}
      name={name}
      label={label}
      required={required}
      error={error}
      helperText={helperText}
      disabled={disabled}
      fullWidth={fullWidth}
      className={className}
    >
      <MuiTextField
        id={id}
        name={name}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        variant="outlined"
        fullWidth={fullWidth}
        disabled={disabled}
        error={Boolean(error)}
        multiline
        rows={rows}
        maxRows={maxRows}
        size="small"
        inputProps={inputProps}
        {...rest}
      />
    </BaseField>
  );
};

TextAreaField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  rows: PropTypes.number,
  maxRows: PropTypes.number,
  inputProps: PropTypes.object,
};

TextAreaField.defaultProps = {
  required: false,
  disabled: false,
  fullWidth: true,
  value: '',
  rows: 4,
};

export default TextAreaField;
